import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslocoModule } from "@ngneat/transloco";
import { TRANSLATION_SCOPE, translationProvider } from "./assets/i18n/translation.provider";

@Component({
  standalone: true,
  selector: 'rx-applications-boolean-cell',
  template: `<span *transloco="let t; read: TRANSLATION_SCOPE">{{ t(label) }}</span>`,
  imports: [CommonModule, TranslocoModule],
  providers: [translationProvider]
})
export class BooleanCellComponent implements ICellRendererAngularComp {
  label!: string;

  readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE

  agInit(params: ICellRendererParams): void {
    this.label = params.value ? 'yes' : 'no';
  }

  refresh(): boolean {
    return false;
  }
}